import { render, staticRenderFns } from "./icon-kakao.vue?vue&type=template&id=34b52652&scoped=true&"
import script from "./icon-kakao.vue?vue&type=script&lang=js&"
export * from "./icon-kakao.vue?vue&type=script&lang=js&"
import style0 from "./icon-kakao.vue?vue&type=style&index=0&id=34b52652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b52652",
  null
  
)

export default component.exports